import { tv } from "../../../variants/tv.js";
const overlayInputVariants = tv({
    slots: {
        root: 'relative grid w-full grid-cols-[40px_1fr] gap-1',
        icon: 'flex items-center justify-center',
        input: ''
    }
});
export { overlayInputVariants };
